import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import { environment } from 'environments/environment';

import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core'; //added by kuldeep on 10-03-2018
import { MomentDateAdapter } from '@angular/material-moment-adapter'; //added by kuldeep on 10-03-2018
import * as _moment from 'moment'; //added by kuldeep on 10-03-2018
import * as _rollupMoment from 'moment'; //added by kuldeep on 10-03-2018
import { process, State } from '@progress/kendo-data-query';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { GroupDescriptor, DataResult } from '@progress/kendo-data-query';
import { Observable } from 'rxjs/Observable';
import { SelectableSettings } from '@progress/kendo-angular-grid';
import { GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { Broadcaster } from 'environments/broadcaster';
import { AuthService } from '../../../_services';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { PagerService } from '../../../_services/pager.service';
import { LoaderService } from '../../../_services/loader.service';
import { DomSanitizer } from '@angular/platform-browser';

const moment = _rollupMoment || _moment;
export const MY_FORMATS = {
  parse: {
    dateInput: 'LL'
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};

declare var $: any;
declare var $: any;
const distinct = (data) => data.filter((x, idx, xs) => xs.findIndex((y) => y.zone === x.zone) === idx);

const distinctWard = (data) => data.filter((x, idx, xs) => xs.findIndex((y) => y.ward === x.ward) === idx);

const distinctStatus = (data) => data.filter((x, idx, xs) => xs.findIndex((y) => y.status === x.status) === idx);

const distinctCCD = (data) => data.filter((x, idx, xs) => xs.findIndex((y) => y.CONSMRCD === x.CONSMRCD) === idx);

const distinctConsName = (data) => data.filter((x, idx, xs) => xs.findIndex((y) => y.CONSMRNAME === x.CONSMRNAME) === idx);

@Component({
  selector: 'app-e-invoicing',
  templateUrl: './e-invoicing.component.html',
  styleUrls: ['./e-invoicing.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class EInvoicingComponent implements OnInit {
  public state: State = {
    skip: 0,
    take: 150,
    // Initial filter descriptor
    filter: {
      logic: 'and',
      filters: []
    }
  };
  IMAGEURL2: 'https://ecogreenassets.s3.ap-south-1.amazonaws.com/EcogreenLogo.png';
  IMAGEURL3: 'https://ecogreenassets.s3.ap-south-1.amazonaws.com/ECOGREEN_KCCQR.jpg';
  sentMail: any;
  ccd: any;
  isCheque: boolean = true;
  bankLists: any;
  paymentMethods: { id: number; mode: string; }[];
  bankName: any;
  getConsumerPanPO: any;
  consumersList: any[]
  finalInvoiceList: any[];

  public allData(): ExcelExportData {
    const result: ExcelExportData = {
      data: this.invoiceList
    };
    return result;
  }

  public pageSize: any;
  public checkboxOnly = false;
  public mode = 'multiple';
  public selectableSettings: SelectableSettings;
  public distinctZone: any[];
  public distinctWard: any[];
  public distinctStatus: any[];
  public distinctCCD: any[];
  public distinctConsName: any[];
  public groups: GroupDescriptor[] = [];
  public view: Observable<GridDataResult>;
  public gridView: DataResult;
  public hiddenColumns: string[] = [];
  public prjGovCode: any;
  month: any;
  year: any;
  public isHidden(columnName: string): boolean {
    return this.hiddenColumns.indexOf(columnName) > -1;
  }
  public groupChange(groups: GroupDescriptor[]): void {
    this.groups = groups;
    this.loadProducts();
  }

  private loadProducts(): void {
    this.gridView = process(this.invoiceList, { group: this.groups });
  }

  mailInvoiceData: any;
  public filteredInvoiceData: any;
  public manualSelectedData: any;
  public gridData: GridDataResult;
  public invoiceList: any;
  public prjId;
  any;
  public invoiceTypeName: any;
  zoneList: any;
  showLoader: any;
  search: any;
  invoiceState: any;
  invoiceId: any;
  remark: any;
  userId: any;
  stateLog: any;
  invoiceType: any;
  selectedInvoiceCount: any;
  statusData: any;
  dispatched: any;
  open: any;
  delivered: any;
  followUp: any;
  paymentReadyOnline: any;
  paymentReadyCash_Cheque: any;
  paymentConfirmed: any;
  invalidPaymentCount: any;
  paid: any;
  total: any;
  paymentDate: any;
  paymentMode: any;
  transactionNumber: any;
  selectedInvoice: any;
  paymentAmount: any;
  noData: any;
  fromDate1: any;
  invoiceStage: any;
  paymentReadyMode: any;
  nextfollowupDate: any;
  isSaveFolloup: any;
  isPymentReady: any;
  paymentHistory: any;
  noPayment: any;
  isChangestate: any;
  stateChangeErrorMsg: any;
  chequeDate: any;
  itemMasterData: any;
  invoiceDataForPrint: any;
  ADDRESS: any;
  COMPANYNAME: any;
  GSTIN: any;
  TOLLFREE: any;
  IMAGEURL1: any;
  PANNO: any;
  invoiceTypeArray: any;
  isManualSelection: any;
  fDate: any;
  tDate: any;
  invoiceHtmlContent: any;
  invoiceText: any;
  invoiceLable: any;
  invoiceDateLable: any;
  statusRemark: any;
  invoiceCancel: any;
  paidCount: any;
  invDate: any;
  wardList: any;
  piStartDate: any;
  piEndDate: any;
  piDateRange: any;
  tiStartDate: any;
  tiEndDate: any;
  tiDateRange: any;
  employeList: any;
  bulkActionLabel: any;
  clientManagerId: any;
  zoneId: any;
  wardId: any;
  statusList: any;
  followupStatus: any;
  followupStatusName: any;
  filterData: any = {};
  searching: any;
  selectedForDispatch: any;
  isPaymentSaving: any;
  authtoken: any;
  startDate: any;
  endDate: any;
  defaultStartDate: any;
  defaultEndDate: any;
  dataRangeModal: any;
  
  constructor(
		private broadcaster: Broadcaster,
		private auth: AuthService,
		private http: HttpClient,
		private routes: ActivatedRoute,
		private router: Router,
		private pagerService: PagerService,
		private loaderService: LoaderService,
		private domSanitizer: DomSanitizer
	) {
		this.loaderService.status.subscribe((val: boolean) => {
			this.showLoader = val;
		});
		this.allData = this.allData.bind(this);
		var date = new Date();
		var firstDay = new Date(date.getFullYear() - 3, date.getMonth() - 8, 1);
		this.defaultStartDate = firstDay.getFullYear() + '-' + (firstDay.getMonth() + 1) + '-' + firstDay.getDate();
		this.defaultEndDate = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
		this.dataRangeModal = {
			beginDate: { year: firstDay.getFullYear(), month: firstDay.getMonth() + 1, day: firstDay.getDate() },
			endDate: { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() }
		};
	}

  clearPaymentData() {
    this.transactionNumber = null;
    this.paymentMode = null;
    this.paymentDate = new Date();
    this.remark = null;
    this.paymentAmount = 0;
  }
  
  selectMode(data){
    if(data){
      if (data.mode == 'Cheque'){
        this.isCheque = false
        this.http.get(environment.apiUrl + 'bankMaster').subscribe(data => {
          var result:any
          result = data
          this.bankLists = result
        });
      }
      else {
        this.isCheque = true
        this.bankName = null 
        $('.bankDropDown').css('cursor','not-allowed');
      }
    }
    else{
      alert("Please select a payment mode!")
      this.isCheque = true
      this.bankName = null 
      this.paymentMode = null 
      return;
    }
    console.log(data, this.paymentMode,this.bankName)
  }
  
  selectBank(data){
    console.log(data, this.bankName)
    if(data.name == null){
      alert("Please select a Bank !")
      return;
    }
  }

  selectInvoiceType(data) {
    if (data == 'All') {
      this.getAllInvoice('All');
    } else if (data == 'Approved') {
      this.getAllInvoice('Approved');
    } else {
      this.getAllInvoice('notApproved');
    }
    //this.searchFilter()
    //this.getInvoiceStatusCount(this.prjId)
  }
  
  async getAllInvoice(approveStatus) {
    this.loaderService.display(true);
    var prjid = this.prjId
    var startdate = this.piStartDate
    var enddate = this.piEndDate
    let result = await fetch(
      environment.apiUrl + 'invoice/getEInvoiceData?prjid=' + prjid + '&startDate=' + startdate + '&endDate=' + enddate + '&approveStatus=' + approveStatus ,
      {
        method: 'get',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: this.authtoken.token
        }
      }
    );
    this.invoiceList = await result.json();
    this.gridData = process(this.invoiceList, this.state);
    this.loaderService.display(false);
    // this.distinctCCD = distinctCCD(this.invoiceList);
    // this.distinctConsName = distinctConsName(this.invoiceList);
    // this.allData = this.allData.bind(this);
    // if (this.invoiceList.length == 0) {
    //   this.noData = true;
    // } else {
    //   this.noData = false;
    // }
  }

  pdf() {
    this.filteredInvoiceData = [];
    if (this.invoiceType == 0) {
      this.invoiceTypeName = 'PERFORMA INVOICE';
      this.invoiceLable = 'PI NO :';
      this.invoiceDateLable = 'PI  DATE :';
      this.invoiceText = null;
    } else {
      this.invoiceTypeName = 'TAX INVOICE';
      this.invoiceText = '(ORIGINAL COPY)';
      this.invoiceLable = 'INVOICE NO :';
      this.invoiceDateLable = 'INVOICE DATE :';
    }
    $('#pInvoiceModal').modal('show');
    if (!this.isManualSelection) {
      this.filteredInvoiceData = this.gridData.data;
    } else {
      this.filteredInvoiceData = this.manualSelectedData;
    }
  }

  printPdf(): void {
    let printContents, popupWin;

    printContents = document.getElementById('print-section').innerHTML;
    // console.log(printContents);
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
        </head>
    <body onload="window.print();window.close()">${printContents}</body>
      </html>`);
    popupWin.document.close();
  }

  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.gridData = process(this.invoiceList, this.state);
    this.distinctCCD = distinctCCD(this.invoiceList);
    this.distinctConsName = distinctConsName(this.invoiceList);
    this.selectedInvoiceCount = this.gridData.data.length;
    this.manualSelectedData = [];
  }

  tDateChange(data) {
    var monthArray = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    var lastDate = new Date(this.tDate).getDate();
    var month = new Date(this.tDate).getMonth();
    if (monthArray[month] != lastDate) {
      alert('please select last date of month');
      this.tDate = moment(new Date()).endOf('month');
      return;
    }
  }

  piDateRangeChanged(dataRange) {
    if (dataRange.beginDate.day > 0) {
      this.startDate = dataRange.beginDate.year + "-" + dataRange.beginDate.month + "-" + dataRange.beginDate.day
      this.endDate = dataRange.endDate.year + "-" + dataRange.endDate.month + "-" + dataRange.endDate.day
      this.getAllInvoice('All')
    }
    else if (dataRange.beginDate.day == 0) {
      this.startDate = this.defaultStartDate;
      this.endDate = this.defaultEndDate;
      this.getAllInvoice('All')
    }
  }

  clearFilter() {
    this.filterData = {};
  }

  selectionChange(data) {
    // console.log(data);
    // this.isManualSelection = true;
    // if (!data.selected) {
    //   if (data.deselectedRows.length > 1) {
    //     this.manualSelectedData = [];
    //   }
    //   this.deselectInvoice(data.deselectedRows[0].dataItem.invoiceNo);
    //   return;
    // }

    // if (data.selectedRows.length > 1) {
    //   this.manualSelectedData = [];
    //   for (var i = 0; i < data.selectedRows.length; i++) {
    //     this.manualSelectedData.push(data.selectedRows[i].dataItem);
    //   }
    //   return;
    // }
    // if (!data.ctrlKey) {
    //   this.manualSelectedData = [data.selectedRows[0].dataItem];
    // } else {
    //   this.manualSelectedData.push(data.selectedRows[0].dataItem);
    // }
  }

  ngOnInit() {
    this.authtoken = JSON.parse(localStorage.getItem('authData'));
    this.pageSize = 10;
    this.searching = false;
    this.invoiceTypeArray = ['Approved', 'Not Approved'];
    this.selectableSettings = {
      mode: 'multiple'
    };
    this.paymentMethods = [
      {id:1,mode: 'Online(NEFT)'},
      {id:2,mode: 'Cash'},
      {id:3,mode: 'Cheque'},
      {id:4,mode: 'PayTM'},
      {id:5,mode: 'Ecogreen Online Payment'}
    ]
    this.noData = false;
    this.prjId = this.auth.getAuthentication().projectId;
    this.userId = this.auth.getAuthentication().id;
    var lastDay = new Date();
    var date = new Date();
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    this.piStartDate = moment(
      new Date(firstDay.getFullYear() + '-' + (firstDay.getMonth() + 1) + '-' + firstDay.getDate())
    ).format('YYYY-MM-DD');
    this.piEndDate = moment(
      new Date(lastDay.getFullYear() + '-' + (lastDay.getMonth() + 1) + '-' + lastDay.getDate())
    ).format('YYYY-MM-DD');
    this.piDateRange = {
      beginDate: { year: firstDay.getFullYear(), month: firstDay.getMonth() + 1, day: firstDay.getDate() },
      endDate: { year: lastDay.getFullYear(), month: lastDay.getMonth() + 1, day: lastDay.getDate() }
    };

    this.tiStartDate = moment(
      new Date(firstDay.getFullYear() + '-' + (firstDay.getMonth() + 1) + '-' + firstDay.getDate())
    ).format('YYYY-MM-DD');
    this.tiEndDate = moment(
      new Date(lastDay.getFullYear() + '-' + (lastDay.getMonth() + 1) + '-' + lastDay.getDate())
    ).format('YYYY-MM-DD');
    this.tiDateRange = {
      beginDate: { year: firstDay.getFullYear(), month: firstDay.getMonth() + 1, day: firstDay.getDate() },
      endDate: { year: lastDay.getFullYear(), month: lastDay.getMonth() + 1, day: lastDay.getDate() }
    };
    this.fDate = new Date();
    this.tDate = moment(new Date()).endOf('month');
    if (this.prjId == 1) {
      this.prjGovCode = 'MCL';
    }
    if (this.prjId == 2) {
      this.prjGovCode = 'MCG';
    }
    if (this.prjId == 3) {
      this.prjGovCode = 'MCF';
    }
    var date = new Date();
		var firstDay = new Date(date.getFullYear() - 3, date.getMonth() - 8, 1);
		this.defaultStartDate = firstDay.getFullYear() + '-' + (firstDay.getMonth() + 1) + '-' + firstDay.getDate();
    this.defaultEndDate = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    this.getAllInvoice('All')
  }
}



// WEBPACK FOOTER //
// ./src/app/crm/kcc/e-invoicing/e-invoicing.component.ts